import { useRouter } from "@tanstack/react-router";
import { AccountProfile } from "@/components/accounts/AccountProfile";

interface Props {
  id: string;
}

export function AccountDetailPage({ id }: Props) {
  const router = useRouter();

  function handleBack() {
    router.navigate({ to: "/dashboard/accounts" });
  }

  return <AccountProfile accountId={id} onBack={handleBack} />;
}
